import { create } from 'zustand'

import type { BusinessCreate } from '../../shared/schemas/business'

interface FormData extends BusinessCreate {
  desiredLocationType?: 'exact' | 'general' | null
}

interface BusinessCreateState {
  totalSteps: number
  formData: FormData
  setFormData: (formData: FormData) => void
  setTotalSteps: (totalSteps: number) => void
  getFormData: () => FormData
  reset: () => void
}

export const useBusinessCreateStore = create<BusinessCreateState>((set, get) => ({
  totalSteps: 1,
  formData: {},
  setFormData: (formData) => set({ formData }),
  setTotalSteps: (totalSteps) => set({ totalSteps }),
  getFormData: () => get().formData,
  reset: () =>
    set({
      totalSteps: 1,
      formData: {},
    }),
}))
